import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex, Skeleton, Button } from 'antd';

import { confirmations } from './../../components/Confirmations';


import { IsFormSaved } from '../../context/FromStatusContext';

import { actionsStruct } from './struct';
import { Evaluations } from './Tables';

const { actionSection, actionButtonNext, actionButtonPrev } = actionsStruct;


const Evaluation = ({ menu }) => {
  const navigate = useNavigate();
  const { isFormSaved } = useContext(IsFormSaved);



  return (
    <div>
      {menu ? (
        <>
          <Evaluations menu={menu} />
          <br />

          <Flex {...actionSection}>
            {menu.prevMenu ? (
              <Button
                {...actionButtonPrev}
                onClick={() =>
                  isFormSaved
                    ? navigate(`/evaluation/${menu.prevMenu}`)
                    : confirmations.forRouteChange(() =>
                      navigate(`/evaluation/${menu.prevMenu}`)
                    )
                }
              >
                Prev
              </Button>
            ) : (
              <></>
            )}
            {menu.nextMenu ? (
              <Button
                {...actionButtonNext}
                onClick={() =>

                  isFormSaved
                    ? navigate(`/evaluation/${menu.nextMenu}`)
                    : confirmations.forRouteChange(() =>
                      navigate(`/evaluation/${menu.nextMenu}`)
                    )
                }
              >
                Next
              </Button>
            ) : (
              <></>
            )}
          </Flex>
        </>
      ) : (
        <Skeleton loading={!menu ? true : false} active />
      )}
    </div>
  );
};

export default Evaluation;
